import d from "@babel/runtime/helpers/esm/objectSpread2";
import P from "@babel/runtime/helpers/esm/classCallCheck";
import T from "@babel/runtime/helpers/esm/createClass";
import w from "@babel/runtime/helpers/esm/inherits";
import M from "@babel/runtime/helpers/esm/createSuper";
import s from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as A } from "@semcore/utils/lib/core/index";
import F, { sstyled as p, assignProps as u, Component as R } from "@semcore/core";
import a from "react";
import { Flex as j } from "@semcore/flex-box";
import $ from "@semcore/icon/Close/m";
import B from "@semcore/utils/lib/enhances/resolveColorEnhance";
import { FadeInOut as L } from "@semcore/animation";
import { isAdvanceMode as O } from "@semcore/utils/lib/findComponent";
import { localizedMessages as h } from "./translations/__intergalactic-dynamic-locales.mjs";
import V from "@semcore/utils/lib/enhances/i18nEnhance";
import { cssVariableEnhance as q } from "@semcore/utils/lib/useCssVariable";
import D from "@semcore/button";
import H from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
var J = (
  /*__reshadow_css_start__*/
  (A.insert(
    /*__inner_css_start__*/
    ".___SNoticeGlobal_19tlz_gg_{display:flex;align-items:center;font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%);box-sizing:border-box;padding:var(--intergalactic-spacing-2x, 8px) var(--intergalactic-spacing-8x, 32px)}.___SCloseIcon_19tlz_gg_{margin-left:var(--intergalactic-spacing-4x, 16px)}.___SNoticeGlobal_19tlz_gg_._theme_neutral_19tlz_gg_{background-color:var(--intergalactic-bg-primary-muted, #6c6e79);color:var(--intergalactic-text-primary-invert, #ffffff)}.___SNoticeGlobal_19tlz_gg_._theme_info_19tlz_gg_{background-color:var(--intergalactic-bg-primary-info, #008ff8);color:var(--intergalactic-text-primary-invert, #ffffff)}.___SNoticeGlobal_19tlz_gg_._theme_danger_19tlz_gg_{background-color:var(--intergalactic-bg-primary-critical, #ff4953);color:var(--intergalactic-text-primary-invert, #ffffff)}.___SNoticeGlobal_19tlz_gg_._theme_warning_19tlz_gg_{background-color:var(--intergalactic-bg-primary-warning, #ff642d);color:var(--intergalactic-text-primary-invert, #ffffff)}.___SNoticeGlobal_19tlz_gg_._theme_success_19tlz_gg_{background-color:var(--intergalactic-bg-primary-success, #009f81);color:var(--intergalactic-text-primary-invert, #ffffff)}.___SNoticeGlobal_19tlz_gg_._theme_custom_19tlz_gg_{background-color:var(--backgroundColor_19tlz)}.___SContent_19tlz_gg_{flex:1 1 auto;width:100%;justify-content:center}",
    "19tlz_gg_"
  ), {
    __SNoticeGlobal: "___SNoticeGlobal_19tlz_gg_",
    __SCloseIcon: "___SCloseIcon_19tlz_gg_",
    _theme_neutral: "_theme_neutral_19tlz_gg_",
    _theme_info: "_theme_info_19tlz_gg_",
    _theme_danger: "_theme_danger_19tlz_gg_",
    _theme_warning: "_theme_warning_19tlz_gg_",
    _theme_success: "_theme_success_19tlz_gg_",
    _theme_custom: "_theme_custom_19tlz_gg_",
    "--backgroundColor": "--backgroundColor_19tlz",
    __SContent: "___SContent_19tlz_gg_"
  })
);
function K(r) {
  return !["danger", "warning", "success", "info", "neutral"].includes(r);
}
var c = /* @__PURE__ */ function(r) {
  w(e, r);
  var i = M(e);
  function e() {
    return P(this, e), i.apply(this, arguments);
  }
  return T(e, [{
    key: "getCloseIconProps",
    value: function() {
      var o = this.asProps.getI18nText;
      return {
        getI18nText: o
      };
    }
  }, {
    key: "render",
    value: function() {
      var o = this.asProps, n, g = L, t = this.asProps, m = t.Children, b = t.styles, C = t.hidden, l = t.theme, y = t.closable, z = t.onClose, x = t.forcedAdvancedMode, S = t.resolveColor, N = t.getI18nText, I = l === "danger" || l === "warning", k = S(l), G = K(l) ? "custom" : l, E = x || O(m, [f.Content.displayName]);
      return n = p(b), /* @__PURE__ */ a.createElement(g, n.cn("SNoticeGlobal", d({}, u({
        visible: !C,
        "use:theme": G,
        backgroundColor: k,
        role: "region",
        "aria-live": I ? "assertive" : "polite",
        "aria-label": N(l === "danger" ? "criticalNotification" : "notification")
      }, o))), E ? /* @__PURE__ */ a.createElement(m, n.cn("Children", {})) : /* @__PURE__ */ a.createElement(f.Content, null, /* @__PURE__ */ a.createElement(m, n.cn("Children", {}))), y && /* @__PURE__ */ a.createElement(f.CloseIcon, {
        onClick: z
      }));
    }
  }]), e;
}(R);
s(c, "displayName", "NoticeGlobal");
s(c, "style", J);
s(c, "enhance", [V(h), q({
  variable: "--intergalactic-duration-popper",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
}), B()]);
s(c, "defaultProps", {
  theme: "neutral",
  i18n: h,
  locale: "en"
});
function Q(r) {
  var i = arguments[0], e, _ = r.styles, o = j;
  return e = p(_), /* @__PURE__ */ a.createElement(o, e.cn("SContent", d({}, u({}, i))));
}
function v(r) {
  var i = arguments[0], e, _ = r.styles, o = r.children, n = r.Children, g = r.getI18nText, t = D;
  return e = p(_), /* @__PURE__ */ a.createElement(t, e.cn("SCloseIcon", d({}, u({
    "aria-label": g("close"),
    use: "tertiary",
    theme: "invert",
    size: "m",
    addonLeft: o ? void 0 : $
  }, i))), o ? /* @__PURE__ */ a.createElement(n, e.cn("Children", {})) : null);
}
v.enhance = [H()];
var f = F(c, {
  Content: Q,
  CloseIcon: v
});
export {
  f as default
};
